export const portalRu = {

  // ── Onboarding survey (/portal/onboarding) ───────────────────────────────
  onboarding: {
    title: "Добро пожаловать — чем мы можем помочь?",
    subtitle: "Расскажите, что вас привело, чтобы мы направили вас в нужный раздел.",
    later: "Я сделаю это позже",
    back: "Назад",
    choices: {
      applyTitle: "Подать заявку на Thailand Elite : виза Thailand Privilege",
      applyDesc: "Начните оформление членства / визы для длительного пребывания.",
      memberTitle: "Я уже участник Thailand Elite",
      memberDesc: "Привяжите своё членство или запросите услуги для участников.",
      prospectTitle: "У меня есть вопросы перед решением",
      prospectDesc: "Получите информацию и поговорите с консультантом.",
      partnerTitle: "Я представляю агентство или партнёра",
      partnerDesc: "Узнайте о вариантах партнёрства и реферальной программы.",
      otherTitle: "Что-то другое",
      otherDesc: "Другой запрос — расскажите, чем мы можем помочь.",
      servicesTitle: "Недвижимость, страхование и другие услуги",
      servicesDesc: "Недвижимость, страховка, другая виза или помощь с переездом в Таиланд.",
    },
    applicant: {
      heading: "Несколько быстрых вопросов",
      subtitle: "Это поможет нам адаптировать вашу заявку. Вы сможете изменить это позже.",
      purposeLabel: "Какова основная причина выбора Thailand Elite?",
      timelineLabel: "Когда вы планируете подать заявку или переехать?",
      submit: "Перейти к моей заявке",
    },
    purpose: {
      retirement: "Выход на пенсию / длительное пребывание",
      business: "Бизнес / работа",
      family: "Семья / иждивенцы",
      investment: "Инвестиции",
      lifestyle: "Образ жизни / частые поездки",
      other: "Другое",
    },
    timeline: {
      asap: "Как можно скорее",
      m1_3: "В течение 1–3 месяцев",
      m3_6: "Через 3–6 месяцев",
      m6_12: "Через 6–12 месяцев",
      exploring: "Пока просто изучаю",
    },
    member: {
      heading: "С возвращением — давайте найдём ваше членство",
      subtitle: "Укажите свой номер участника, и наша команда привяжет его к этому аккаунту после быстрой проверки.",
      idLabel: "Номер участника / карты",
      idPlaceholder: "напр. TPC123456",
      sinceLabel: "Когда вы стали участником?",
      sincePlaceholder: "напр. 2022",
      viaLabel: "Как вы подавали заявку?",
      viaPlaceholder: "Агент, напрямую и т. д.",
      helpLabel: "Чем мы можем помочь?",
      helpPlaceholder: "Опишите ваш запрос (вклейка визы, отчёт за 90 дней, продление…).",
      submit: "Отправить",
    },
    inquiry: {
      heading: "Расскажите немного подробнее",
      subtitle: "Мы передадим ваш запрос нужному специалисту и свяжемся с вами.",
      typeLabel: "О чём ваш запрос?",
      messageLabel: "Ваше сообщение",
      messagePlaceholder: "Расскажите, чем мы можем вам помочь.",
      submit: "Отправить запрос",
    },
    inquiryTypes: {
      general_inquiry: "Общий вопрос",
      member_service: "Действующий участник — запрос услуги",
      partnership: "Агентство / партнёрство",
      visa_other: "Другой вопрос по визе / иммиграции",
      other_services: "Недвижимость, страхование или другие услуги",
      other: "Другое",
    },
    services: {
      heading: "Чем мы можем помочь?",
      subtitle: "Выберите всё, что вас интересует, — мы свяжем вас с подходящим партнёром.",
      interestsLabel: "Меня интересует",
      messageLabel: "Хотите что-то добавить?",
      messagePlaceholder: "Например: ищу кондо в Бангкоке, медицинскую страховку на двоих…",
      submit: "Отправить",
      needInterestTitle: "Выберите хотя бы один вариант",
      needInterestDesc: "Расскажите, что вас интересует.",
    },
    interests: {
      real_estate: "Недвижимость",
      insurance: "Медицинская / туристическая страховка",
      other_visa: "Другая виза",
      business_setup: "Открытие бизнеса",
      relocation: "Помощь с переездом (школы, банк…)",
      extraLabel: "Можем ли мы помочь вам с чем-то ещё в Таиланде?",
    },
    deleteAccount: {
      link: "Создали аккаунт по ошибке? Удалить его",
      title: "Удалить аккаунт?",
      desc: "Ваш аккаунт и введённые данные будут удалены навсегда. Это действие нельзя отменить.",
      confirm: "Удалить мой аккаунт",
      cancel: "Отмена",
      doneTitle: "Аккаунт удалён",
      doneDesc: "Ваш аккаунт удалён. Будем рады видеть вас снова.",
      failedTitle: "Не удалось удалить аккаунт",
      notEligible: "У этого аккаунта есть заявка или членство. Напишите нам, и мы закроем его для вас.",
    },
    done: {
      title: "Ваш запрос отправлен",
      desc: "Спасибо — наша команда рассмотрит его и свяжется с вами в ближайшее время.",
      cta: "Перейти в личный кабинет",
    },
    optionalTag: "(необязательно)",
    memberOutcome: {
      linkedTitle: "Членство привязано ✓",
      linkedDesc: "С возвращением — ваш раздел участника готов.",
      pendingTitle: "Почти готово — подтвердите ваше членство",
      pendingDesc: "Мы отправили подтверждение на вашу зарегистрированную почту ({{email}}). После вашего подтверждения и одобрения нашей командой членство будет привязано.",
    },
    banner: {
      memberTitle: "Спасибо — мы проверяем ваше членство",
      memberDesc: "Наша команда вскоре привяжет ваш номер участника к этому аккаунту. Вы получите уведомление после подтверждения.",
      prospectTitle: "Спасибо за обращение",
      prospectDesc: "Консультант свяжется с вами с запрошенной информацией. Готовы подать заявку? Вы можете начать в любой момент ниже.",
      partnerTitle: "Спасибо за интерес к партнёрству",
      partnerDesc: "Готовы стать нашим партнёром? Отправьте профиль вашей компании, чтобы начать — или наша команда по партнёрству свяжется с вами.",
      partnerCta: "Стать партнёром",
      otherTitle: "Ваш запрос получен",
      otherDesc: "Наша команда рассмотрит его и свяжется с вами в ближайшее время.",
    },
    toast: {
      saveFailedTitle: "Не удалось сохранить",
      saveFailedDesc: "Пожалуйста, попробуйте снова.",
      applicantOkTitle: "Отлично — начнём",
      applicantOkDesc: "Теперь вы можете начать свою заявку.",
      needMessageTitle: "Добавьте короткое сообщение",
      needMessageDesc: "Расскажите, чем мы можем помочь.",
    },
  },
  common: {
    saveAndContinue: "Сохранить и продолжить",
    back: "Назад",
    submit: "Подать заявку",
    submitting: "Отправка…",
    saving: "Сохранение…",
    uploading: "Загрузка…",
    required: "Обязательно",
    optional: "необязательно",
    yes: "Да",
    no: "Нет",
    select: "Выбрать…",
    uploaded: "Загружено",
    missing: "Отсутствует",
    loading: "Загрузка…",
    download: "Скачать",
    upload: "Загрузить",
    remove: "Удалить",
    retry: "Повторить",
    next: "Далее",
    close: "Закрыть",
    addDocuments: "Добавить документы",
    signOut: "Выйти",
    memberPortal: "Портал участника",
    language: "Язык",
    // Toast messages
    fileTooLarge: "Файл слишком большой",
    maxSizeAllowed: "Максимум {{size}}.",
    uploadFailed: "Не удалось загрузить",
    invalidEmail: "Неверный email",
  },

  dashboard: {
    nextMemberApp: "Заявка Дополнительного Члена",
    addNextMember: "Добавить дополнительного члена",
    nextMemberPromo: "Акция: 750 000 THB за дополнительного члена до 31.12.2026",
    myApplications: "Мои заявки",
    noApplications: "Нет заявок",
    noApplicationsDesc: "Начните своё путешествие с Thailand Elite, создав первую заявку.",
    createApplication: "Создать заявку",
    newApplication: "Новая заявка",
    resumeApplication: "Продолжить заявку",
    alreadyActiveTitle: "Заявка уже в процессе",
    alreadyActiveDesc: "У вас уже есть активная заявка. Завершите или отмените её перед созданием новой.",
    package: "Программа",
    created: "Создано",
    messages: "Сообщения",
    newThread: "Новый чат",
    newThreadSubject: "Тема",
    newThreadBody: "Сообщение",
    generalInquiry: "Общий вопрос",
    noMessages: "Сообщений пока нет",
    status: {
      open: "Открыт",
      waiting_reply: "Ожидание ответа",
      closed: "Закрыт",
      draft: "Черновик",
      submitted: "Подана",
      under_review: "На рассмотрении",
      background_check: "Проверка биографии",
      approved: "Одобрена",
      payment_pending: "Ожидает оплаты",
      payment_done: "Ожидает активации",
      active: "Активна",
      cancelled: "Отменена",
      rejected: "Отклонена",
    },
  },

  membership: {
    card: {
      sectionTitle: "Ваша карта участника",
      tierLabel:    "Членство",
      holderLabel:  "Владелец карты",
      numberLabel:  "Номер карты",
      validFrom:    "Действительна с",
      validUntil:   "Действительна до",
      printOrSave:  "Распечатать или сохранить в PDF",
    },
    documents: {
      lettersTitle:                "Официальные письма",
      welcomeLetter:               "Приветственное письмо",
      welcomeLetterDesc:           "Ваше официальное приветственное письмо Thailand Elite",
      welcomeLetterPending:        "Будет загружено вашим агентом после подтверждения активации",
      certificationLetter:        "Сертификационное письмо",
      certificationLetterDesc:    "Официальный сертификационный документ Thailand Privilege",
      certificationLetterPending: "Доступно после выдачи Thailand Privilege",
      pending:                    "В ожидании",
    },
  },

  services: {
    tabLabel:           "Услуги",
    title:              "Услуги для участников",
    intro:              "Отправьте запрос на услугу — проставление визы, уведомление за 90 дней или любой другой вопрос. Ваш номер участника прикрепляется автоматически.",
    chooseType:         "Выберите услугу",
    noTypes:            "В данный момент нет доступных типов услуг. Пожалуйста, свяжитесь со службой поддержки.",
    estimated:          "~{{days}} рабочих дней",
    history:            "Ваши предыдущие запросы",
    back:               "Назад к услугам",
    requirementsTitle:  "Что вам нужно предоставить",
    memberIdLabel:      "Отправка от имени",
    subject:            "Тема",
    messageLabel:       "Опишите ваш запрос",
    messagePlaceholder: "Добавьте любые детали, которые помогут нам обработать ваш запрос быстрее.",
    attachments:        "Вложения",
    addFile:            "Нажмите для загрузки (PDF / JPG / PNG, макс. 10 МБ)",
    send:               "Отправить запрос",
    submittedTitle:     "Запрос отправлен",
    submittedDesc:      "Наша команда по услугам для участников рассмотрит запрос и ответит через Сообщения.",
    submittedDescMcc:      "Наша команда рассмотрит запрос и ответит в Сообщениях. Чтобы ускорить обработку, отправьте готовое письмо в MCC ниже.",
    mcc: {
      title: "Связаться с MCC напрямую",
      intro: "Эту услугу бронирует Member Contact Center (MCC) Thailand Privilege. Отправьте им это готовое письмо на английском со своей почты — мы получим копию и проконтролируем ответ.",
      titleNext: "Ускорьте запрос: напишите в MCC",
      recommended: "Рекомендуется · быстрее обработка",
      oneMinute: "Это займёт минуту: письмо готово, просто нажмите «Отправить».",
      attachReminder: "Документы не прикрепляются автоматически (конфиденциальность). Прикрепите их к письму: {{files}}",
      linksIncluded: "Ваши документы включены в письмо в виде защищённых ссылок (действуют до {{date}}). Их также можно прикрепить.",
      copyTip: "Совет: нажмите «Скопировать письмо» и вставьте его в почту, названия файлов станут ссылками.",
      emailButton: "Написать в MCC",
      gmailButton: "Открыть в Gmail",
      callButton: "Позвонить в MCC",
      copyButton: "Скопировать письмо",
      copied: "Письмо скопировано.",
      preview: "Показать письмо",
      hidePreview: "Скрыть письмо",
      confirmEmailTitle: "Вы отправили письмо в MCC?",
      confirmPhoneTitle: "Вам удалось связаться с MCC?",
      confirmHint: "MCC обычно отвечает в течение нескольких часов. В срочных случаях отправьте письмо и также позвоните по номеру {{phone}}.",
      yes: "Да",
      notYet: "Пока нет",
      statusEmail: "Вы написали в MCC {{date}}.",
      statusPhone: "Вы позвонили в MCC {{date}}.",
      copyReceived: "Мы получили копию вашего письма.",
      followupTitle: "Вы получили ответ от MCC?",
      answered: "Да, всё решено",
      needHelp: "Нет, нужна помощь",
      thanks: "Спасибо, отметили.",
      helpSent: "Мы займёмся этим: наша команда свяжется с MCC за вас.",
      packageTitle: "Ваше членство: {{package}}",
      privilegePoints: "Привилегированные баллы",
      privilegeBook: "Privilege Book 2026 (PDF)",
      mccLine: "Member Contact Center: {{email}} · {{phone}}",
      done: "Готово",
    },
    details: {
      whereTitle: "Где вы хотите вклеить визу?",
      airport: "В аэропорту, по прилёте",
      airportHint: "Прилёт не раньше чем через 7 дней. Подготовьте авиабилет.",
      chaeng: "В иммиграционном офисе Чэнг Ваттана, Бангкок",
      chaengHint: "Рабочий день не раньше чем через 5 рабочих дней. Нужна копия TM30.",
      arrivalAirport: "Аэропорт прилёта",
      flightNumber: "Номер рейса",
      departureFrom: "Вылет из",
      departurePlaceholder: "напр. Москва SVO",
      arrivalDate: "Дата прилёта",
      arrivalTime: "Время прилёта (местное)",
      ticket: "Авиабилет или маршрутная квитанция",
      ticketHint: "PDF или фото. Мы проверим, что он совпадает с рейсом выше.",
      ticketChecking: "Проверяем билет…",
      ticketMatch: "Билет проверен: рейс и дата совпадают.",
      ticketMismatch: "Проверьте, пожалуйста, билет:",
      ticketUnreadable: "Не удалось прочитать билет автоматически. Наша команда проверит его.",
      preferredDate: "Желаемая дата",
      period: "Время суток",
      morning: "Утро (9:00–12:00)",
      afternoon: "После обеда (13:00–16:00)",
      alternativeDate: "Запасной вариант (необязательно)",
      tentative: "Даты предварительные; Member Services подтверждает их в зависимости от наличия мест.",
      tm30: "Копия TM30 (подтверждение адреса)",
      tm30Hint: "Квитанция TM30 от арендодателя или отеля.",
      passportCopy: "Копия паспорта (страница с фото)",
      passportHint: "Паспорт, в который будет вклеена виза. Если у вас новый паспорт, загрузите его.",
      passportFromApplication: "Из вашей заявки",
      useApplicationPassport: "Использовать паспорт из моей заявки",
      passportNewWarning: "Это не тот паспорт, с которым вы подавали заявку. С новым паспортом иммиграционной службе может потребоваться повторная проверка перед вклейкой визы, что может занять больше времени. Мы сообщим, если понадобится что-то ещё.",
      tm30Guide: "Что такое TM30?",
      upload: "Загрузить",
      replace: "Заменить",
      bank: "Банк",
      bankPlaceholder: "Выберите банк",
      city: "Город",
      branch: "Отделение (необязательно)",
      branchPlaceholder: "напр. Silom, Central World",
      bankHint: "Окончательное решение принимает банк; он может запросить дополнительные документы.",
      ninetyTitle: "О 90-дневном уведомлении",
      ninetySummary: "Форма TM47 подтверждает ваш адрес каждые 90 дней непрерывного пребывания. Выезд из Таиланда обнуляет счёт. Подать можно за 15 дней до и в течение 7 дней после срока; за опоздание штраф 2 000 THB.",
      readGuide: "Читать полное руководство",
      messageOptional: "Что-нибудь ещё, что нам стоит знать?",
      noMessage: "См. детали ниже.",
      licenseType: "Категория прав",
      car: "Автомобиль",
      motorcycle: "Мотоцикл",
      both: "Автомобиль и мотоцикл",
      office: "Отделение Department of Land Transport",
      chatuchak: "Чатучак, Бангкок",
      otherOffice: "Другое отделение",
      otherOfficePlaceholder: "Город / отделение",
      homeLicense: "Действующие водительские права вашей страны",
      residenceCertificate: "Справка о проживании",
      residenceCertificateHint: "Выдаётся вашим посольством (или разрешение на работу).",
      medicalCertificate: "Медицинская справка",
      medicalCertificateHint: "Из клиники в Таиланде, выдана не ранее месяца назад. Её можно получить и перед визитом.",
      drivingIntro: "Оформляется за один день в Department of Land Transport вместе с нашим сопровождающим. Возьмите паспорт с визой Privilege.",
      drivingGuide: "Руководство по водительским правам",
      epaService: "Услуга",
      epaArrival: "Прилёт",
      epaDeparture: "Вылет",
      epaAirport: "Аэропорт",
      flightDate: "Дата рейса",
      flightTime: "Время рейса (местное)",
      originCity: "Город вылета",
      originCityPlaceholder: "напр. Москва",
      passengers: "Количество пассажиров",
      epaHint: "EPA работает с 06:00 до 24:00. Бронируйте не позднее чем за 5 часов до рейса.",
      optional: "необязательно",
      docType: "Тип документа",
      docTypes: {
        passport: "Паспорт",
        visa_page: "Страница визы",
        photo: "Фото",
        entry_stamp: "Штамп о въезде",
        tm30: "TM30",
        flight_ticket: "Авиабилет",
        home_license: "Водительские права (страна)",
        residence_certificate: "Справка о проживании",
        medical_certificate: "Медицинская справка",
        other: "Другой документ",
      },
      phone: "Номер телефона (для MCC)",
      phoneHint: "Из вашего профиля. Можно изменить.",
      fromApplication: "Добавить из моей заявки",
      fromApplicationHint: "Документы, уже загруженные с заявкой. Загружать их заново не нужно.",
      appDocs: {
        passport_photo: "Страница паспорта с фото",
        passport_signature: "Страница паспорта с подписью",
        visa: "Страница визы",
        arrival_stamp: "Штамп о въезде",
        profile_photo: "Фото",
        marriage_certificate: "Свидетельство о браке",
        birth_certificate: "Свидетельство о рождении",
      },
      errors: {
        licenseTypeRequired: "Выберите категорию прав.",
        officeRequired: "Выберите отделение.",
        homeLicenseRequired: "Загрузите водительские права вашей страны.",
        residenceCertificateRequired: "Загрузите справку о проживании.",
        epaServiceRequired: "Выберите прилёт или вылет.",
        flightDateRequired: "Введите дату рейса.",
        flightDatePast: "Дата рейса уже прошла.",
        flightTimeRequired: "Введите время рейса.",
        epaTooSoon: "EPA нужно бронировать не позднее чем за 5 часов до рейса.",
        originCityRequired: "Введите город вылета.",
        locationRequired: "Выберите, где вклеить визу.",
        airportRequired: "Выберите аэропорт прилёта.",
        flightNumberInvalid: "Введите номер рейса, напр. TG931.",
        arrivalDateRequired: "Введите дату прилёта.",
        arrivalTooSoon: "Прилёт должен быть {{date}} или позже (через 7 дней).",
        arrivalTimeRequired: "Введите время прилёта.",
        preferredDateRequired: "Выберите желаемую дату.",
        weekend: "Иммиграционный офис не работает в выходные. Выберите понедельник–пятницу.",
        appointmentTooSoon: "Выберите {{date}} или позже (через 5 рабочих дней).",
        periodRequired: "Выберите утро или после обеда.",
        alternativeInvalid: "Запасной вариант — рабочий день, {{date}} или позже.",
        tm30Required: "Загрузите копию TM30.",
        passportRequired: "Приложите копию паспорта.",
        bankRequired: "Выберите банк.",
        cityRequired: "Выберите город.",
      },
    },
  },

  wizard: {
    applicationSteps: "Шаги заявки",
    step: "Шаг",
    of: "из",
    readOnlyBanner: "Эта заявка была подана. Свяжитесь со службой поддержки, чтобы запросить изменения.",
    readOnlySupportLink: "Запросить изменение",
    backgroundCheckTitle: "Заявка на рассмотрении",
    backgroundCheckBody: "В настоящее время ваша заявка рассматривается нашей командой и соответствующими тайскими органами. На данном этапе вашу заявку нельзя отменить или изменить. Если у вас есть вопросы, пожалуйста, свяжитесь с нашей службой поддержки.",
    backgroundCheckExpected: "Вы можете получить письмо об одобрении примерно к:",
    backgroundCheckNote: "* Это ориентировочный срок, основанный на стандартной обработке в течение 4–8 недель. Он не гарантируется.",
    backgroundCheckContact: "По вопросам обращайтесь к нашей команде:",
    steps: {
      package: "Программа",
      passport: "Паспорт",
      personalInfo: "Личные данные",
      address: "Адрес",
      visa: "Виза и въезд",
      documents: "Документы",
      review: "Проверка",
    },
    stepDescriptions: {
      package: "Выберите программу членства Thailand Elite",
      passport: "Загрузите и верифицируйте ваш паспорт",
      personalInfo: "Заполните личные данные",
      address: "Ваш адрес проживания и контактные данные",
      visa: "Текущий статус визы и въезда",
      documents: "Загрузите и подпишите необходимые документы",
      review: "Проверьте и подайте заявку",
    },
  },

  nextMember: {
    title: "Заявка дополнительного члена",
    subtitle: "Вы подаёте заявку как дополнительный член в рамках существующего основного членства.",
    badge: "Дополнительный член",
    addButton: "Добавить дополнительного члена",
    relationship: "Родство с основным участником",
    selectRelationship: "Выберите родство…",
    relationships: {
      spouse: "Супруг(а)",
      child: "Ребёнок",
      parent: "Родитель",
      adopted_child: "Приёмный ребёнок",
      civil_union: "Партнёр по гражданскому союзу",
    },
    coreApplication: "Основная заявка",
    additionalFee: "Дополнительный взнос за члена",
    promoLabel: "Акционная цена",
    regularFee: "Обычная цена",
    promoUntil: "Действует до 31.12.2026",
    perMember: "/чел.",
    existingNextMember: "Заявка дополнительного члена",
  },

  package: {
    title: "Выбор программы",
    subtitle: "Выберите программу членства Thailand Elite, которая подходит вам больше всего.",
    selected: "Выбрано",
    selectPackage: "Выбрать программу",
    years: "лет",
    perYear: "в год",
    includes: "Включает",
    familyOption: "Доступна семейная опция",
  },

  passport: {
    title: "Верификация паспорта",
    subtitle: "Загрузите страницу с личными данными паспорта для верификации OCR.",
    uploadTitle: "Загрузить фото паспорта",
    uploadDesc: "Фото или скан страницы с личными данными паспорта (JPG, PNG, PDF — макс. 10 МБ)",
    uploadHint: "Нажмите для загрузки или сделайте фото",
    extractTitle: "Извлечь данные",
    extractDesc: "Нажмите, чтобы ИИ заполнил ваши данные автоматически — это займёт несколько секунд",
    retakePhoto: "Переснять / Загрузить снова",
    passportNumber: "Номер паспорта",
    surname: "Фамилия",
    givenName: "Имя",
    nationality: "Гражданство",
    dateOfBirth: "Дата рождения",
    sex: "Пол",
    dateOfIssue: "Дата выдачи",
    dateOfExpiry: "Срок действия",
    placeOfBirth: "Место рождения",
    mrz: "Машиносчитываемая зона (MRZ)",
    extractedData: "Извлечённые данные",
    verifyAndContinue: "Подтвердить и продолжить",
    lowConfidenceWarning: "Некоторые поля не удалось чётко распознать. Проверьте данные перед продолжением.",
    expiryWarning: "Для подачи заявки паспорт должен быть действителен не менее 6 месяцев.",
    expiryModalTitle: "Проблема со сроком действия паспорта",
    expiryModalDesc: "Срок действия паспорта должен превышать 1 год с даты подачи заявки. Пожалуйста, обновите паспорт перед подачей заявки.",
    expiryModalCta: "Понятно",
    // Scan requirements
    scanRequirements: "Требования к сканированию",
    scanReqColor: "Полноцветный скан — без чёрно-белого",
    scanReqEdges: "Видны все четыре края",
    scanReqResolution: "Высокое разрешение, весь текст читаем",
    scanReqFocus: "Без размытия и расфокусировки",
    gallery: "Галерея",
    scanning: "Сканирование…",
    uploadDifferentFile: "Загрузить другой файл",
    fileFormatHint: "JPG, PNG или PDF · макс. 10 МБ",
    // Gender options
    male: "Мужской",
    female: "Женский",
    // Placeholders
    cityOrTown: "Город или населённый пункт",
    country: "Страна",
    asShownOnPassport: "Как указано в паспорте",
    ifApplicable: "Если применимо",
    // Toast messages
    passportUploaded: "Паспорт загружен",
    passportUploadedDesc: "Нажмите «Сканировать и заполнить с помощью AI», чтобы извлечь ваши данные.",
    passportScanned: "Паспорт отсканирован ✓",
    passportScannedDesc: "Проверьте извлечённые данные ниже.",
    qualityIssuesDetected: "Обнаружены проблемы с качеством",
    scanUnavailable: "Сканирование недоступно",
    scanUnavailableDesc: "Пожалуйста, заполните ваши данные вручную ниже.",
    applicationAlreadyExists: "Заявка уже существует",
    applicationAlreadyExistsDesc: "Предыдущая заявка для {{name}} уже была начата. Пожалуйста, продолжите её или свяжитесь со службой поддержки, если это новый заявитель.",
    // OCR quality issues
    blurryImage: "Размытое изображение",
    reflectionDetected: "Обнаружены отражения / блики",
    glareOnPassport: "Блики на паспорте",
    imageCropped: "Изображение обрезано — отсканируйте заново, показав паспорт полностью",
    bioPageComplete: "Страница с данными заполнена",
    mrzReadable: "MRZ читается",
    // Signature section
    signaturePage: "Страница с подписью",
    signatureOptional: "Необязательно",
    signaturePageRequired: "Загрузите страницу паспорта с вашей собственноручной подписью, если её нет на странице с личными данными.",
    signatureDetectedOnBio: "Ваша подпись обнаружена на странице с личными данными. Вы также можете загрузить отдельную страницу с подписью, если она есть в вашем паспорте.",
    signatureDetectedConfirm: "Подпись обнаружена на странице с данными паспорта ✓",
    signatureDetectedNote: "Если в вашем паспорте также есть отдельная страница с подписью (часто встречается во французских, итальянских, немецких паспортах), вы можете загрузить её ниже.",
    signatureNotCorrect: "Неверно — на этой странице нет подписи",
    noSignatureOnBioPage: "Подпись не найдена на странице с данными",
    noSignatureOnBioPageNote: "В некоторых паспортах нет подписи на странице с данными — пожалуйста, загрузите страницу с вашей подписью. Это обязательно для паспортов из: <strong>Сингапура, Филиппин, Малайзии, Индонезии, Швеции, ОАЭ, Саудовской Аравии, Катара, Кувейта, Бахрейна, Омана</strong>, а также для большинства детских паспортов.",
    signaturePageUploaded: "Страница с подписью загружена",
    uploadSignaturePageOptional: "Загрузить страницу с подписью (необязательно)",
    uploadSignaturePage: "Загрузить страницу с подписью",
    replace: "Заменить",
    pdf: {
      label: "PDF паспорта",
      openPreview: "Открыть предпросмотр PDF",
      detectedNote: "Обнаружен PDF — страница паспорта считывается прямо из PDF.",
    },
    ocrCooldown: "Подождите несколько секунд перед повторной попыткой.",
  },

  personalInfo: {
    title: "Личные данные",
    subtitle: "Проверьте и заполните ваш профиль и детали заявки.",
    profilePhoto: {
      title: "Фото на документ",
      desc: "Чёткое, свежее фото вашего лица (паспортный формат). Необходимо для вашей карты участника.",
      uploadButton: "Загрузить фото",
      changeButton: "Изменить фото",
      takePhoto: "Сделать фото",
      saved: "Сохранено",
      photoSaved: "Фото сохранено ✓",
      photoUploadFailed: "Не удалось загрузить фото",
      removeBackgroundAi: "Удалить фон с помощью AI",
      removeBackgroundNote: "Фон будет заменён на белый — применяется при следующей загрузке.",
    },
    identity: {
      sectionTitle: "Личность",
      title: "Обращение",
      givenName: "Имя",
      middleName: "Отчество",
      surname: "Фамилия",
      nameOnCard: "Имя на карте Elite",
      nameOnCardHint: "Имя, которое будет указано на карте участника",
      dateOfBirth: "Дата рождения",
      gender: "Пол",
      occupation: "Род занятий",
      businessIndustry: "Отрасль деятельности",
    },
    applicationDetails: {
      sectionTitle: "Детали заявки",
      sectionDesc: "Предзаполнено из скана паспорта. Данные паспорта автоматически имеют приоритет.",
      fromPassport: "Из паспорта",
      nationality: "Гражданство",
      placeOfBirth: "Место рождения",
      countryOfBirth: "Страна рождения",
    },
    nationalityCheck: {
      question: "Есть ли у вас в настоящее время другое гражданство?",
      otherNationality: "Другое гражданство",
      passportsIntro: "Укажите все другие паспорта и гражданства. Эти данные вносятся в декларацию о нескольких паспортах и гражданствах (стр. 2 анкеты), которую вы подпишете.",
      passportHeading: "Другой паспорт {{n}}",
      passportNumber: "Номер паспорта",
      issueDate: "Дата выдачи",
      expiryDate: "Дата окончания",
      nameOnPassport: "Полное имя в этом паспорте (если отличается)",
      addPassport: "Добавить паспорт",
      passportRequired: "Укажите гражданство и номер другого паспорта.",
      requiredDocsTitle: "Документы для заявителей с несколькими гражданствами:",
      reqDoc1: "Паспорт(а) первоначального гражданства, а также прежние паспорта, если менялись имя или фамилия.",
      reqDoc2: "Официальные документы об отказе от первоначального гражданства (если применимо).",
      reqDoc3: "Документы, подтверждающие доход и происхождение средств для оплаты членства.",
      reqDoc4: "Подтверждение постоянного проживания в Таиланде или за рубежом за последние 6 месяцев.",
      mismatchTitle: "Страна рождения отличается от вашего гражданства",
      mismatchIntro: "Мы также заметили, что ваша страна рождения отличается от страны гражданства, хотя вы указали, что имеете только одно гражданство.",
      mismatchBody: "Обратите внимание: иммиграционные органы предъявляют строгие требования при вклейке визы и могут запросить дополнительные документы. Если у вас двойное гражданство, его необходимо указать. Если вы отказались от предыдущего гражданства, подготовьте соответствующие подтверждающие документы.",
      listTitle: "При необходимости предоставьте:",
      doc1: "Чёткую копию второго паспорта.",
      doc2: "Копию свидетельства о гражданстве или другого документа, подтверждающего, как вы получили текущее гражданство, с кратким пояснением.",
      doc3: "Копию документа об отказе от гражданства, если ранее у вас было другое гражданство, от которого вы отказались.",
      explanationLabel: "Краткое пояснение (необязательно)",
      explanationPlaceholder: "напр. Родился в Бразилии, получил гражданство в 2010 г., от бразильского гражданства отказался в 2012 г.",
      uploadTitle: "Подтверждающие документы",
      uploadDesc: "PDF, JPG или PNG — до 10 МБ каждый.",
    },
    contact: {
      phone: "Телефон",
      phonePlaceholder: "+66 XX XXX XXXX",
      email: "Электронная почта",
      emailHint: "Используется для вашей заявки. Может отличаться от почты для входа.",
    },
    sharedProfile: "Общий профиль",
    fillAllRequiredFields: "Пожалуйста, заполните все обязательные поля",
  },

  address: {
    title: "Адрес",
    subtitle: "Ваш текущий адрес проживания.",
    currentAddress: "Текущий адрес",
    street: "Адрес",
    streetHint: "Автодополнение OpenStreetMap",
    startTyping: "Начните вводить адрес…",
    city: "Город",
    state: "Регион / Провинция",
    country: "Страна",
    postalCode: "Почтовый индекс",
    thaiAddress: "Адрес в Таиланде",
    haveThaiAddress: "У меня есть адрес в Таиланде",
    accommodationType: "Тип жилья",
    province: "Провинция",
    district: "Район",
    subDistrict: "Подрайон",
    thaiTelephone: "Телефон (Таиланд)",
    thaiPhoneNote: "Номер телефона в Таиланде (без ведущего 0)",
    validationError: "Укажите улицу, город и страну",
  },

  visa: {
    title: "Статус визы и въезда",
    subtitle: "Ваша текущая тайская виза и информация о въезде.",
    currentVisa: "Текущая тайская виза",
    hasThaiVisa: "Есть ли у вас сейчас тайская виза?",
    visaType: "Тип визы",
    visaExpiry: "Срок действия визы",
    uploadVisaPage: "Фото страницы с визой",
    uploadVisaBtn: "Загрузить страницу с визой",
    arrivalStamp: "Штамп о въезде",
    hasArrivalStamp: "Есть ли у вас сейчас штамп о въезде?",
    stampExpiry: "Срок действия штампа",
    uploadStampPage: "Фото страницы со штампом",
    uploadStampBtn: "Загрузить страницу со штампом",
    passportStatus: "Статус паспорта",
    blankVisaPages: "Более 3 чистых визовых страниц в паспорте?",
    blankYes: "Да — более 3",
    blankNo: "Нет — 3 или меньше",
    overstayCount: "Нарушений срока пребывания в Таиланде (за 3 последних года)",
    overstayNever: "0 — Никогда",
    otherVisaOption: "Другое (укажите)",
    otherVisaLabel: "Укажите вашу визу",
    otherVisaPlaceholder: "Краткий код, напр. Non-O, SMART-T",
    edVisa: {
      sectionTitle: "История визы для обучения (ED)",
      sectionDesc: "Обязательное указание для оценки соответствия требованиям Thailand Elite.",
      question: "Была ли у вас виза для обучения (ED) в последние 5 лет или в текущем паспорте?",
      warningTitle: "Требуются дополнительные подтверждающие документы",
      warningDesc: "Приём заявителей с историей учебной визы зависит от предоставления следующих документов. Отсутствие документов может привести к отказу.",
      doc1: "Лицензия на открытие учебного заведения (สช.2 / OBEC / OPEC)",
      doc2: "Регистрация учебного заведения (ร.2)",
      doc3: "Справка об обучении от учебного заведения",
      doc4: "Академические записи, табели успеваемости и журнал посещаемости",
      doc5: "Фотографии занятий",
      doc5Optional: "(необязательно — загрузить позже, если недоступно)",
      acknowledgementForm: "Форма подтверждения",
      acknowledgementFormDesc: "Скачайте, заполните и загрузите вместе с подтверждающими документами",
      uploadTitle: "Загрузить подтверждающие документы",
      uploadDesc: "PDF, JPG или PNG — можно загрузить несколько файлов. Надёжно сохраняются в вашей заявке.",
    },
  },

  visaReminder: {
    title: "Важно — сохраняйте действительную визу",
    body: "Пожалуйста, всегда поддерживайте действующую визу, если вы находитесь в Таиланде. Подача этой заявки не предоставляет вам какого-либо продления срока пребывания или разрешения оставаться в Таиланде. Если вы в настоящее время находитесь в Таиланде, убедитесь, что ваша виза остаётся действительной на протяжении всего процесса рассмотрения заявки.",
  },

  documents: {
    title: "Документы",
    subtitle: "Скачайте, подпишите и загрузите ваши формы заявки.",
    applicationForm: {
      title: "Форма заявки",
      desc: "Скачайте предзаполненную форму заявки, подпишите её электронной подписью, затем загрузите.",
      download: "Скачать предзаполненный PDF",
      signDigitally: "Подписать электронно",
      signatureCapture: "Ввести подпись",
      signatureCaptureDesc: "Нарисуйте вашу подпись ниже",
      clear: "Очистить",
      save: "Сохранить подпись",
      appliedTo: "Применено ко всем страницам",
      uploadSigned: "Загрузить подписанную форму",
    },
    pdpaForm: {
      title: "Форма согласия PDPA",
      desc: "Согласие по закону о защите персональных данных. Скачайте, подпишите и загрузите.",
      download: "Скачать форму PDPA",
      signDigitally: "Подписать электронно",
      uploadSigned: "Загрузить подписанную форму",
    },
    uploadStatus: "Статус загрузки",
    viewDocument: "Просмотреть загруженный документ",
    downloadDocument: "Скачать подписанный PDF",
    signingComplete: "Подпись завершена — загрузите для сохранения",
    remaining: "осталось",
    requiredDocuments: "Необходимые документы",
    continueToReview: "Перейти к проверке",
    blankForm: "Пустая форма",
    blankAddendum: "Пустое промо-приложение",
    downloadLabel: "Скачать",
    reprefill: "Заполнить заново",
    // Toast messages for DocumentsStep
    applicationFormPrefilled: "Форма заявки предзаполнена",
    applicationFormPrefilledDesc: "Скачано! Подпишите каждую страницу, затем загрузите или подпишите электронно.",
    prefillFailed: "Не удалось предзаполнить",
    applicationFormSigned: "Форма заявки подписана и сохранена ✓",
    signingFailed: "Не удалось подписать",
    applicationFormUploaded: "Форма заявки загружена ✓",
    pdpaFormSigned: "Форма согласия PDPA подписана и сохранена ✓",
    pdpaFormUploaded: "Форма согласия PDPA загружена ✓",
    documentUploaded: "Документ загружен ✓",
    uploaded: "Загружено ✓",
    translationUploaded: "Перевод загружен ✓",
    uploadTranslation: "Загрузить перевод",
    relationshipProof: {
      title: "Документы, подтверждающие родство",
      subtitle: "Загрузите официальные документы, подтверждающие ваше родство с основным участником.",
      marriageCert: "Свидетельство о браке",
      birthCert: "Свидетельство о рождении",
      adoptionCert: "Свидетельство об усыновлении",
      civilUnionCert: "Свидетельство о гражданском союзе",
      notInEnglish: "Этот документ не на английском языке",
      certifiedTranslation: "Заверенный перевод на английский",
    },
    signatureCapture: {
      title: "Электронная подпись (необязательно)",
      subtitle: "Нарисуйте или загрузите вашу подпись для применения ко всем документам заявки.",
      saved: "Подпись сохранена",
      willBeApplied: "Будет применена ко всем документам",
      confirm: "Я понимаю и хочу подписать электронно",
      disclaimer1: "Заявитель должен лично подписать все страницы заявки. Если заявителю меньше 20 лет, законный представитель также должен поставить подпись.",
      disclaimer2: "Все подписи должны в точности совпадать с подписью в паспорте.",
      disclaimer3: "⚠️ Мы допускаем электронные подписи, но учтите, что в некоторых случаях Thailand Privilege Card может запросить полностью распечатанную, подписанную от руки и отсканированную копию всех страниц. Если у вас есть принтер и сканер, мы настоятельно рекомендуем распечатать и подписать от руки.",
      options: {
        upload: {
          title: "Загрузить подпись",
          desc: "Загрузите изображение вашей подписи",
          instruction: "Нажмите или перетащите файл изображения сюда",
          enhancing: "Улучшение…",
          clickToUpload: "Нажмите для загрузки",
        },
        passport: {
          title: "Использовать подпись из паспорта",
          desc: "Извлеките вашу подпись из загруженного скана паспорта",
          passportRef: "Скан паспорта",
          notFound: "Скан паспорта не найден — пожалуйста, сначала загрузите ваш паспорт",
          instruction: "Нажмите, чтобы извлечь подпись из паспорта",
          uploadBtn: "Извлечь из паспорта",
        },
        draw: {
          title: "Нарисовать подпись",
          desc: "Нарисуйте вашу подпись мышью или пальцем",
        },
      },
    },
  },

  review: {
    title: "Проверка и подача",
    subtitle: "Проверьте заявку перед отправкой.",
    applicationSummary: "Сводка заявки",
    membershipPackage: "Программа членства",
    fullName: "Полное имя",
    nationality: "Гражданство",
    dateOfBirth: "Дата рождения",
    passportNo: "Номер паспорта",
    passportExpiry: "Срок действия паспорта",
    occupation: "Род занятий",
    country: "Страна",
    city: "Город",
    phone: "Телефон",
    email: "Эл. почта",
    remaining: "осталось",
    requiredDocuments: "Необходимые документы",
    passportPhoto: "Фото паспорта / удостоверения личности",
    profilePhoto: "Фото профиля",
    applicationFormSigned: "Форма заявки (подписана)",
    pdpaFormSigned: "Форма согласия PDPA (подписана)",
    missingDocsWarning: "Заполните все необходимые документы на шаге 6 перед подачей.",
    // Validation issues
    validation: {
      fullNameMissing: "Отсутствует полное имя",
      passportNoMissing: "Отсутствует номер паспорта",
      passportExpiryMissing: "Отсутствует срок действия паспорта",
      passportValidityWarning: "Срок действия паспорта должен превышать 1 год с даты подачи заявки",
      nationalityMissing: "Отсутствует гражданство",
      otherNationalityMissing: "Не дан ответ на вопрос о втором гражданстве",
      phoneMissing: "Отсутствует номер телефона",
      countryMissing: "Отсутствует страна проживания",
      cityMissing: "Отсутствует город",
      missingInfoTitle: "Отсутствует информация — пожалуйста, заполните перед подачей",
      goTo: "Перейти к",
      completeBeforeSubmitting: "Пожалуйста, заполните недостающую информацию выше перед подачей",
      accountFlaggedTitle: "Ваш аккаунт отмечен для проверки",
      uploadFlagged: "Один из загруженных файлов не соответствует нашим правилам для документов, поэтому ваш аккаунт отмечен для проверки. Если это ошибка, напишите нам — наша команда всё проверит.",
      contactUs: "Написать нам",
      passportNotGenuine: "Загруженный файл не является читаемой страницей паспорта с данными (страница с фотографией и двумя строками кода внизу). Загрузите чёткую копию вашего настоящего паспорта.",
      passportDataMismatch: "Некоторые данные не совпадают с отсканированным паспортом: {{fields}}. Исправьте их, чтобы они точно совпадали с паспортом.",
      mismatchConfirm: "Мои данные верны — пусть команда проверит мой паспорт",
      fieldPassportNo: "номер паспорта",
      fieldDob: "дата рождения",
      fieldExpiry: "срок действия паспорта",
    },
    survey: {
      title: "Анкета",
      howDidYouLearn: "Как вы узнали о Thailand Elite?",
      mainReason: "Основная причина подачи заявки?",
      expectation: "Что вы ожидаете от членства?",
    },
    agreement: "Я подтверждаю, что все предоставленные сведения являются точными, полными и достоверными. Я даю согласие на обработку моих персональных данных и документов — включая OCR паспорта и верификацию подписи с помощью ИИ — компаниями Dreamond и Thailand Privilege Card Co., Ltd. в целях рассмотрения моей заявки на членство. Я понимаю, что оплата не требуется до официального одобрения моей заявки, и что любые платежи должны производиться исключительно в пользу Thailand Privilege Card Co., Ltd. на основании их официального счёта. Я ознакомился(-ась) и согласен(-на) с",
    termsAndConditions: "Условиями использования",
    and: "и",
    privacyPolicy: "Политикой конфиденциальности",
    noPaymentNote: "оплата не требуется до официального одобрения",
    missingDocumentsError: "Отсутствуют документы",
    missingDocumentsErrorDesc: "Загрузите все необходимые документы перед подачей.",
    submittedTitle: "Заявка подана!",
    submittedDesc: "Мы рассмотрим вашу заявку и свяжемся с вами.",
    submissionFailed: "Ошибка при подаче",
  },

  screens: {
    common: {
      contactSupport: "По вопросам обращайтесь к нашей команде:",
    },
    approved: {
      title: "Поздравляем! Ваша заявка одобрена",
      message: "Пожалуйста, проверьте вашу электронную почту на наличие письма об одобрении и счёта. Вы должны произвести оплату в течение 30 дней, чтобы активировать ваше членство.",
      uploadTitle: "Загрузить подтверждение оплаты",
      uploadHint: "Квитанция о банковском переводе, скриншот или PDF (макс. 10 МБ)",
      uploadButton: "Загрузить подтверждение оплаты",
      uploadSuccess: "Подтверждение оплаты загружено",
      uploadSuccessDesc: "Финансовый отдел проверит вашу оплату, обычно примерно за 3 рабочих дня.",
      uploadedConfirmation: "Подтверждение оплаты загружено — на рассмотрении",
      cardPaymentTitle: "Оплатить кредитной картой",
      cardPaymentHint: "Запросите защищённую ссылку для оплаты у финансового отдела",
      requestLink: "Запросить ссылку для оплаты картой",
      payByCard: "Оплатить кредитной картой",
      linkRequested: "Запрос отправлен",
      linkRequestedDesc: "Финансовый отдел вскоре отправит вам ссылку для оплаты.",
      note: "Если вы уже загрузили подтверждение оплаты, никаких дополнительных действий не требуется.",
      proofRejectedTitle: "Нам не удалось подтвердить оплату по загруженному документу",
      proofRejectedHelp: "Пожалуйста, загрузите новое подтверждение оплаты ниже. Если у вас есть вопросы, ответьте на наше письмо или свяжитесь с нами.",
    },
    paymentPending: {
      title: "Оплата на проверке",
      message: "Ваше подтверждение оплаты получено и передано в финансовый отдел на проверку. Проверка обычно занимает около 3 рабочих дней, затем около 4 рабочих дней на активацию членства и выпуск приветственного письма.",
      verifying: "Проверка оплаты…",
      uploaded: "Загружено",
      expected: "Ожидаемая проверка",
      uploadDate: "Дата загрузки",
      expectedDate: "Ожидается к",
      activationDate: "Активация примерно",
      note: "Это обычные сроки (всего около 7 рабочих дней). Они могут меняться в зависимости от даты зачисления платежа и загрузки финансового отдела.",
      verifiedTitle: "Оплата проверена",
      verifiedMessage: "Ваша оплата проверена. Сейчас оформляется ваше членство: приветственное письмо обычно приходит примерно в течение 4 рабочих дней.",
      addTitle: "Добавить ещё один платёжный документ",
      addHint: "Если финансовый отдел запросит дополнительные документы или у вас есть выписка по счёту, дебетовое авизо или SWIFT MT103, добавьте их здесь. Все документы собираются вместе для проверки.",
      addButton: "Добавить документ",
      added: "Документ добавлен",
      documentsTitle: "Отправленные документы",
    },
    paymentDone: {
      title: "Оплата подтверждена",
      message: "Ваша оплата подтверждена финансовым отделом. Вы вскоре получите приветственное письмо и информацию о карте участника по электронной почте.",
      verified: "Оплата подтверждена ✓",
      nextStepsTitle: "Что дальше?",
      step1: "Вы получите приветственное письмо по электронной почте",
      step2: "Ваша карта участника будет подготовлена",
      step3: "Мы свяжемся с вами для записи на проставление визы",
      package: "Ваше членство",
    },
    prePayment: {
      title: "Важное уведомление перед оплатой",
      intro: "Не производите оплату, если к вам относится любое из указанных ниже условий.",
      conditions: [
        {
          title: "Действительность въездного штампа",
          detail: "Разрешение на пребывание, указанное во въездном штампе вашего паспорта, должно быть действительным. Заявитель, у которого зафиксировано превышение срока пребывания в течение текущего пребывания, ни при каких обстоятельствах не может получить визу Thailand Privilege.",
        },
        {
          title: "Виза Non-Immigrant O (волонтёрская)",
          detail: "Заявитель, который в настоящее время имеет или когда-либо имел визу Non-Immigrant типа O (волонтёрскую), ни при каких обстоятельствах не может получить визу Thailand Privilege.",
        },
        {
          title: "Виза Non-Immigrant MT или ED",
          detail: "Заявитель, имеющий действующую визу Non-Immigrant MT (лечение) без требуемого заключения больницы или медицинской справки, либо визу Non-Immigrant ED (обучение) без официального документа Office of Basic Education Commission (OBEC) и подтверждающих документов, ни при каких обстоятельствах не может получить визу Thailand Privilege.",
        },
      ],
      warning: "Если к вам относится любое из перечисленных условий, Thailand Privilege Card Co., Ltd. оставляет за собой право удержать членский взнос без возврата.",
      rulesTitle: "Условия оплаты",
      rules: [
        { text: "Членский взнос должен быть переведён одним платежом в соответствии с Anti-Money Laundering Act, B.E. 2542 (1999) и поправками к нему. Перевод через мобильный банк также должен покрывать полную сумму одной операцией." },
        { text: "Сумма, поступившая в Thailand Privilege Card Co., Ltd., должна составлять полный членский взнос. Все банковские комиссии, комиссии банков-корреспондентов, агентские и прочие расходы по переводу оплачиваются вами дополнительно." },
        { text: "Письмо об одобрении и счёт действительны 30 дней с даты выдачи. По истечении срока заявка подлежит повторной проверке." },
        { text: "Платежи, произведённые после указанного в счёте срока, не принимаются и лишают права на любые промоакции." },
        { text: "Карты American Express к оплате не принимаются." },
      ],
      doubt: "Если вы не уверены, относится ли к вам одно из этих условий, свяжитесь с нами до оплаты. Мы предварительно проверим ваше дело.",
    },

    visaAffix: {
      title: "Запрос на проставление визы",
      intro: "Отправьте запрос нашей команде: мы приложим документы, уже имеющиеся в вашем деле, передадим запрос в Member Contact Center и проследим за записью на приём.",
      locationLabel: "Желаемое место проставления",
      locations: {
        chaengWattana: "Иммиграционный офис Чэнг Ваттана, Бангкок",
        suvarnabhumi: "Аэропорт Суварнабхуми, по прибытии",
        phuket: "Международный аэропорт Пхукета, по прибытии",
        chiangMai: "Международный аэропорт Чиангмая, по прибытии",
        overseas: "За пределами Таиланда (e-Visa через дипломатическое представительство)",
      },
      noticeThailand: "Запись требуется за 5-7 рабочих дней и зависит от доступности Elite Personal Liaison.",
      noticeOverseas: "E-Visa оформляется через официальный портал правительства Таиланда. Срок — 15-30 рабочих дней с момента подачи.",
      dateLabel: "Желаемая дата",
      flightLabel: "Рейс прибытия",
      flightPlaceholder: "напр. TG911, 14 окт.",
      documentsLabel: "Документы в вашем деле",
      documentsHint: "Отметьте, что следует приложить. По умолчанию включено всё.",
      documentTypes: {
        passport_photo: "Паспорт",
        application_form: "Анкета",
        consent_form: "Форма согласия",
        payment_proof: "Подтверждение оплаты",
      },
      submit: "Составить запрос",
      mccTitle: "Member Contact Center",
      mccHint: "Чтобы записаться самостоятельно, обратитесь напрямую в MCC и укажите свой членский номер.",
      email: {
        subject: "Запрос на проставление визы",
        intro: "Прошу записать меня на проставление визы Privilege Entry.",
        member: "Участник",
        card: "Членский номер",
        package: "Программа",
        location: "Желаемое место",
        preferredDate: "Желаемая дата",
        flight: "Рейс прибытия",
        documentsHeld: "Просьба приложить из моего дела",
        noneSelected: "Документы не выбраны",
        notSpecified: "Не указано",
        closing: "Благодарю.",
      },
    },

    active: {
      title: "Добро пожаловать в Thailand Elite!",
      subtitle: "Поздравляем — теперь вы официальный участник Thailand Elite.",
      cardNo: "Номер участника",
      package: "Программа",
      validFrom: "Действительна с",
      validUntil: "Действительна до",
      requestVisaAffix: "Запросить проставление визы",
      memberArea: "Личный кабинет участника",
    },
    rejected: {
      title: "Заявка не одобрена",
      titleCancelled: "Заявка отменена",
      message: "К сожалению, ваша заявка не может быть одобрена в данный момент. Если у вас есть вопросы по этому решению, пожалуйста, свяжитесь с нашей службой поддержки.",
      messageCancelled: "Эта заявка была отменена. Если вы хотите подать заявку снова, вы можете начать новую заявку.",
      messageInactive: "Эта заявка была закрыта после длительного периода без активности. Все введённые данные сохранены — вы можете продолжить с того места, где остановились.",
      resume: "Возобновить заявку",
      resumedToast: "С возвращением! Ваша заявка снова открыта.",
      resumeFailed: "Не удалось возобновить заявку. Пожалуйста, напишите нам.",
      info: "Вы можете начать новую заявку, если хотите подать её снова.",
      startNew: "Начать новую заявку",
    },
  },

  auth: {
    login: {
      title: "Портал участника",
      subtitle: "Войдите в свой аккаунт",
      email: "Электронная почта",
      continueWithEmail: "Продолжить с электронной почтой",
      sendingLink: "Отправка ссылки…",
      noPasswordNote: "Мы отправим вам защищённую ссылку для входа — пароль не требуется.",
      noAccount: "Нет аккаунта?",
      createOne: "Создать",
      checkEmailTitle: "Проверьте электронную почту",
      checkEmailDesc: "Мы отправили ссылку для входа на <strong>{{email}}</strong>. Нажмите на ссылку, чтобы получить доступ к своему аккаунту.",
      didntReceive: "Не получили?",
      tryAgain: "Попробовать снова",
      accountDisabledTitle: "Аккаунт отключён",
      accountDisabledMsg: "Ваш аккаунт был отключён.",
      accountDisabledReason: "Причина:",
      accountDisabledContact: "Если вы считаете, что это ошибка, свяжитесь с нами по адресу",
    },
    register: {
      title: "Создать аккаунт",
      subtitle: "Начните своё путешествие с Thailand Elite",
      firstName: "Имя",
      lastName: "Фамилия",
      email: "Электронная почта",
      phoneNumber: "Номер телефона",
      searchCountry: "Искать страну…",
      continueWithEmail: "Продолжить с электронной почтой",
      sendingLink: "Отправка волшебной ссылки…",
      noPasswordNote: "Мы отправим вам защищённую ссылку для подтверждения электронной почты и входа — пароль не требуется.",
      alreadyHaveAccount: "Уже есть аккаунт?",
      signIn: "Войти",
      checkEmailTitle: "Проверьте электронную почту",
      checkEmailDesc: "Мы отправили волшебную ссылку на <strong>{{email}}</strong>. Нажмите на ссылку в письме, чтобы войти и завершить регистрацию.",
      didntReceive: "Не получили?",
      tryAgain: "Попробовать снова",
    },
  },
};
